import { ApiLogLogCertificazioneInfocenterPostRequest, Configuration, LogApi, LogCertificazioneInfoCenterDtoPagedListDto } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';
import { pageSize } from 'store/utils';

/* export const setStatoCertificazioneAction = createAction<number, 'setStatoCertificazione'>('setStatoCertificazione');
export const setModalitaCertificazioneAction = createAction<number, 'setModalitaCertificazione'>('setModalitaCertificazione');
export const setNdgAction = createAction<string, 'setNdgAction'>('setNdgAction'); */
export const setPaginaSelezionataAction = createAction<number, 'logCertificazioni/setPaginaSelezionata'>('logCertificazioni/setPaginaSelezionata');
export const setDataInizio = createAction<Date, 'logCertificazioni/setDataInizio'>('logCertificazioni/setDataInizio');
export const setDataFine = createAction<Date, 'logCertificazioni/setDataFine'>('logCertificazioni/setDataFine');


export const postLogCertificaziniInfocenterAction = createAsyncThunk<LogCertificazioneInfoCenterDtoPagedListDto | undefined, undefined, ThunkApiConfig>(
  'logCertificazioni//postLogCertificaziniInfocenterAction', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        return (await import('../../../../mock/log-certificazioni-infocenter.json')).default;
      } else {
        const logInfoCenterState = getState().logCertificazioniInfocenter;
        const requestParameters: ApiLogLogCertificazioneInfocenterPostRequest = {
          ricercaLogDto: {
            dataInizio: new Date(logInfoCenterState.dataInizio.getFullYear(), logInfoCenterState.dataInizio.getMonth(), logInfoCenterState.dataInizio.getDate(), 0, 0, 0),
            dataFine: new Date(logInfoCenterState.dataFine.getFullYear(), logInfoCenterState.dataFine.getMonth(), logInfoCenterState.dataFine.getDate(), 23, 59, 59),
            pageSize: pageSize,
            pageNumber: logInfoCenterState.paginaSelezionata
          }

        };
        return await new LogApi(getConfiguration(Configuration, extra, getState)).apiLogLogCertificazioneInfocenterPost(requestParameters);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);
